module.exports = __webpack_public_path__ + "static/img/tccDLogo.2933a821.png";